import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { canOpen } from "@/components/shell/navConfig";

const SEMPRE = ["/dashboard", "/novita", "/anagrafiche"];

export const linkUsabile = (user, apps, link) =>
  Boolean(link) && (SEMPRE.some((p) => link === p || (p !== "/dashboard" && link.startsWith(`${p}/`))) || canOpen(user, apps, link));

export const splitVoce = (v) => {
  const i = v.lastIndexOf(" | /");
  return i < 0 ? { testo: v, link: null } : { testo: v.slice(0, i), link: v.slice(i + 3).trim() };
};

export const VoceLink = ({ link, onOpen, testid }) => (
  <Button size="sm" variant="outline" className="h-7 shrink-0 px-2 text-xs" onClick={() => onOpen(link)} data-testid={testid}>
    Apri <ArrowRight className="h-3 w-3 ml-1" />
  </Button>
);
